import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Style from './header.module.scss';
import { Button, AuthContext, WhitelabelContext } from 'components/lib';

const SubscriptionExpiryBar = ({ subscription }) => {
  const authContext = useContext(AuthContext);
  const { whitelabelDetails } = useContext(WhitelabelContext);
  const navigate = useNavigate();

  const isPaidPlan = subscription?.data?.status === 'paid';
  const isExpired = !!subscription?.data?.expired;
  const cancelAtPeriodEnd = !!subscription?.data?.object?.cancel_at_period_end;

  if (!isPaidPlan || (!isExpired && !cancelAtPeriodEnd)) return null;
  if (authContext?.user?.permission === 'client') return null;

  const agencyName = whitelabelDetails?.agencyName || 'SalesBlink';
  const expiryDate = subscription?.data?.object?.current_period_end;

  return (
    <div className={`${Style.danger} ${Style.responsiveInfo}`}>
      <p>
        {isExpired
          ? `Your subscription has expired. Resubscribe to continue using ${agencyName}.`
          : `Your subscription expires on ${expiryDate}. Resubscribe to continue using ${agencyName}.`}
      </p>
      <Button
        variant="primary"
        text="RESUBSCRIBE"
        action={() => navigate('/account/billing')}
        style={{ fontSize: 14, padding: '4px 7px', minWidth: 'fit-content' }}
      />
    </div>
  );
};

export default SubscriptionExpiryBar;
